// main.js 顶部加入
(function () {
  const origAddEventListener = EventTarget.prototype.addEventListener;

  EventTarget.prototype.addEventListener = function (type, listener, options) {
    // 只给滚动或触摸相关事件加 passive
    const passiveEvents = ["touchstart", "touchmove", "wheel", "mousewheel", "scroll"];

    if (passiveEvents.includes(type)) {
      // 如果 options 是布尔值（capture）
      if (typeof options === "boolean") {
        options = { capture: options, passive: true };
      }
      // 如果 options 是对象
      else if (typeof options === "object") {
        options = { ...options, passive: true };
      }
      // 如果 options 为空
      else {
        options = { passive: true };
      }
    }

    return origAddEventListener.call(this, type, listener, options);
  };
})();



// WEBPACK FOOTER //
// ./src/plugins/passive.js